import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  @Input() headers: string[] = [];
  @Input() data: any[] = [];
  @Input()fetchingData: boolean = false;
  @Input() action: ((id: string| number) => void)  = ()=>{};
  @Input() remove: ((id: string| number) => void)  = ()=>{};
  @Input() canDelete: boolean = false;
  @Input() canResend: boolean = false;
  remove_=(id: string)=>{
    if (this.canDelete)
    this.remove(id)
  }
}
